module.exports = __webpack_public_path__ + "img/txt_to-official.37ede73b.png";